<template>
  <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
    <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
      <v-data-table :search="search" :headers="headers" :items="commissions" :items-per-page="5">
        <template v-slot:item.details="{ item }">
          <div class="d-flex align-center justify-center">
            <v-dialog transition="scale-transition" origin="center center" max-width="820" v-model="dialog[item?.id]"
              content-class="commission-tree">
              <template v-slot:activator="{ on, attrs }">
                <div class="links text-decoration-none mr-3">
                  <div @click="handleSplitCommission(item)" v-bind="attrs" v-on="on" v-if="access === 1">
                    <v-icon color="#039de9" small>
                      mdi-pencil-outline
                    </v-icon>
                    <v-icon class="ml-4" color="#039de9" small>
                      mdi mdi-eye-outline
                    </v-icon>
                  </div>

                  <div v-else>
                   ...
                  </div>
                  
                </div>
              </template>

              <v-stepper v-model="e1" class="password-stepper admin-password-stepper">
                <v-stepper-items>
                  <v-stepper-content step="1" class="pa-0">
                    <v-card class="deposit-form create-account-form" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'
                      ">
                      <v-row dense>
                        <v-card class="deposit-form create-account-form" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'
                          ">
                          <v-row dense>
                            <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark
                              ? 'blue-darken-1'
                              : 'white-lighten-5'
                              ">
                              <v-card-title
                                class="pb-1 pt-0 justify-space-between font-weight-bold pl-3"
                              >
                                <span>View Commission Split</span>
                                <!-- <a
                                  target="_blank"
                                  class="text--green text-decoration-underline"
                                  href="https://www.youtube.com/watch?v=oRDRfikj2z8&t=1s"
                                >
                                  See Video
                                </a> -->
                              </v-card-title>
                              <v-card-subtitle class="mt-0 pl-3 pb-4 text--ash tree-commission-label">
                                <span>{{ item.account_type_display }}</span>
                                <span>{{ item.currency_group_title }}</span>
                                <span>L 1 - L{{ viewcommission?.total_ib_levels }}</span>
                                <span>$ {{ item.commission_rate }}</span>
                              </v-card-subtitle>
                              <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark
                                ? 'blue-darken-1'
                                : 'white-lighten-5'
                                ">
                                <commission-split-table :splitData="viewcommission?.commissionRates"
                                  :levelCounts="Number(levelCounts)" :tutorial="viewcommission?.tutorial"
                                  v-model="commissionRates"
                                  @update:splitData="updateSplitData"></commission-split-table>
                              </v-card>
                              <v-card-actions>
                                <v-row>

                                  <v-col cols="6">
                                    <v-btn @click="updateCommission(item)" :ripple="false" tile elevation="0"
                                      class="custom-btn px-10" color="#039de9" large>
                                      Update
                                    </v-btn>
                                    <v-btn @click="handleClose(item)" :ripple="false" tile elevation="0"
                                      class="custom-btn px-10 ml-2" large>
                                      Cancel
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-card-actions>
                            </v-card>
                          </v-row>
                        </v-card>
                      </v-row>
                    </v-card>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-dialog>
          </div>
        </template>
        <template v-slot:item.LevelView="{ item }">
          {{ `L 1 - L ${levelCounts}` }} {{ access }}
        </template>
      </v-data-table>
    </v-sheet>
  </v-card>
</template>

<script>
import { COMMISSIONTREE__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import CommissionSplitTable from "./CommissionSplitTable.vue";

export default {
  components: { CommissionSplitTable },
  props: {
    commissions: {
      type: Array,
    },
    search: {
      type: String,
    },
    levelCounts: {
      type: String,
    },
    access: {
      type: String,
    },
  },
  data() {
    return {
      dialog: {},
      e1: 1,

      headers: [
        { text: "Account Type", value: "account_type_display", align: "start" },
        { text: "Group/Currency", value: "currency_group_title" },
        { text: "Level", value: "LevelView" },
        { text: "Total Commission", value: "commission_rate" },
        { text: "Action", value: "details" },
      ],
    };
  },
  computed: {
    ...mapState("commissiontree", ["viewcommission"]),
    ...mapState("admins", ["loggedAdmin"]),
  },
  methods: {
    ...mapActions("commissiontree", [
      COMMISSIONTREE__ACTIONS.VIEWCOMMISSION,
      COMMISSIONTREE__ACTIONS.UPDATECOMMISSIONTREE,
    ]),

    handleClose(item) {
      this.$set(this.dialog, item?.id, false);
    },

    async handleSplitCommission(item) {
      await this[COMMISSIONTREE__ACTIONS.VIEWCOMMISSION]({
        account_type: item.account_type_id,
        currency_group: item.currency_group_id
      });
    },

    updateSplitData(newData) {
      this.viewcommission.commissionRates = { ...newData };
    },

    updateCommission(item) {
      this[COMMISSIONTREE__ACTIONS.UPDATECOMMISSIONTREE]({
        total_ib_levels: this.viewcommission?.total_ib_levels,
        account_type: item.account_type_id,
        currency_group: item.currency_group_id,
        totalCommission: item.commission_rate,
        commissionRates: this.viewcommission.commissionRates
      })
      this.handleClose(item)
    },

    isValid(){
      if (access == 1) {
        this.headers?.push({ text: "Action", value: "details" });
      }
    }
  },

};
</script>
